// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import BigList from "../../components/BigList"
import ArrowIcon from "../../components/ArrowIcon"
import { connect } from "react-redux"
import { CONFIG_TABLE } from "../ConfigContainer"
import { withRouter } from "react-router-dom"
import { Checkbox, Snackbar, Button, Dropdown } from "react-toolbox"
import styles from "./style.css"
import _ from "lodash"
import * as strings from "../../strings.jsx"
import { toastr } from "react-redux-toastr"
import { generateReport } from "../../actions"
import download from "downloadjs"

// Translates from the config keys, to something we can present to the user
//
// This table is derived from the Table thats shown to the user
// on the config menu, this ensures that we always use the same name
const TRANSLATION_TABLE = CONFIG_TABLE.reduce( ( col, acc ) => ( { ...acc, ...col } ), {} )

const XLSX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

class DebtList extends Component {
  props: {
    items: any,
    userConfig: any,
    pickedDebts: any,
    // This field translates between the keys of the userConfig and the keys received in items
    //
    // The keys of the object must match the keys provided in `props.userConfig`
    // and the values must match the keys in each item
    configItemMap: {},
    itemsPerPage: any,
    handlePageChange: () => any,
    totalItems: any,
    activePage: any,
    loadMore: () => {},
    hasMoreItems: () => boolean,
    onChange: () => any,
    auth: any,
    user: any,
    history: {
      push: () => any,
    },
    filters: any,
    submitToCitius: () => any,
  }
  state = {
    results: undefined,
    openRows: new Set(),
  }

  isChecked = ( element ) => {
    return _.indexOf( this.props.pickedDebts, element ) >= 0
  }

  isAllPicked = () => {
    const items = this.props.items ? this.props.items.data.length : 0
    const pickedDebts = this.props.pickedDebts ? this.props.pickedDebts.length : 0
    return _.isEqual( items, pickedDebts ) || pickedDebts > items // So when we have all debts picked but not shown
  }

  // Returns a columns object accepted by BigList
  prepareColumns = ( config, translation, configItemMap ) => {
    let finalColumns = _.map( config, ( configValue, configKey ) => {
      const userFacingName = translation[ configKey ]
      const objectKey = configItemMap[ configKey ]

      if ( !configValue ) {
        return undefined
      }

      return {
        title: userFacingName,
        key: objectKey,
      }
    } )
    const iconColumn = {
      title: this.props.onChange ? <Checkbox className={this.isAllPicked() ? styles.checkBoxClick : styles.checkBox}
        checked={this.isAllPicked()} onChange={this.props.onChange( "ALL" )}/> : undefined, key: "icon",
    }

    const expandColumn = {
      title: "", key: "iconExpand",
    }


    finalColumns = [ iconColumn, ...finalColumns, expandColumn ]
    return _.compact( finalColumns )
  }

  // Attaches extra properties to each individual item, such as onClick
  prepareItems = items => items.data.map( item => {
    const opened = this.state.openRows.has( item.idDebt )
    return {
      icon: this.props.onChange ? <Checkbox className={this.isChecked( item.idDebt ) ? styles.checkBoxClick : styles.checkBox}
        checked={this.isChecked( item.idDebt )} onChange={this.props.onChange( item.idDebt )}/> : undefined,
      ...item,
      _onClick: () => this.props.history.push( "/debt/" + item.idDebt ),
      iconExpand: <ArrowIcon invert={ opened } onClick={ this.toggleRow( item.idDebt ) } />,
    }
  } )

  toggleRow = ( id ) => ( ) => {
    const { openRows } = this.state
    const fn = !openRows.has( id ) ? "add" : "delete"
    openRows[ fn ]( id )
    this.setState( {
      openRows,
    } )
  }

  submitToCitius = () => {
    if ( this.props.pickedDebts.length === 0 ) {
      return
    }

    this.props.submitToCitius( this.props.pickedDebts )
      .then( res => {
        if ( res.message === "OK" ) {
          toastr.success( "Processos submetidos com sucesso" )
        } else {
          toastr.error( "Occoreu um erro a submeter os processos" )
        }
      } )
  }

  renderRows = ( columns, items ) => {
    const isIcon = columns.map( column => column.key.startsWith( "icon" ) )
    const iconWidth = 3
    const nonIconWidth = ( 100 - isIcon.filter( val => val ).length * iconWidth ) / isIcon.filter( val => !val ).length
    const rows = items.map( ( item ) => {
      return this.customRow( columns, item, iconWidth, nonIconWidth )
    } )

    return (
      <div className={style.items}>
        { rows }
      </div>
    )

  }

  customRow = ( columns, item, iconPercentage, nonIconWidth ) => {
    const fullRender = this.state.openRows.has( item.idDebt )
    return (
      <div className={ style.row }>
        <div key={ item.idDebt } className={ style.itemWrapper } >
          {columns.map( ( column, index ) => {
            const isIcon = column.key.startsWith( "icon" )
            return (
              <div style={{ width: ( !isIcon ? nonIconWidth : iconPercentage ) + "%", "align-items": "center" }}
                key={column.key || index}
                onClick={ !isIcon ? item._onClick : undefined}
                onKeyPress={ !isIcon ? item._onClick : undefined } >
                {
                  column.transform( item[ column.key ], column.key, item ) || "--"
                }
              </div>
            ) } )}
        </div>
        {fullRender ? this.renderExtraInfo( item ) : ""}
      </div>
    )
  }

  renderExtraInfo = ( item ) => {
    const phases = [
      ...item.preLitigations.map( phase => ( { process: "Pré-Contencioso", ...phase } ) ),
      ...item.litigations.map( phase => ( { process: "Contencioso", ...phase } ) ),
      ...item.executions.map( phase => ( { process: "Execução", ...phase } ) ),
    ]

    const subListCols = [ {
      title: strings.processes.processType,
      key: "process",
    }, {
      title: strings.generalStrings.type,
      key: "type",
    }, {
      title: strings.generalStrings.idc,
      key: "idc",
    }, {
      title: strings.processes.injunctionNumber,
      key: "injunctionNumber",
    } ]

    return (
      <div>
        <BigList
          loadMore={ () => false }
          hasMoreItems={ () => false }
          items={phases}
          columns={subListCols}
          enablePagination={false}
        />
      </div>
    )
  }


  renderExportMenu () {
    const reportTypes = _.filter( [
      { value: "none", label: strings.generalStrings.exportReport },
      { value: "generalTable", label: "Tabela Geral", fileExt: "xlsx", mimeType: XLSX_MIME_TYPE },
      {
        value: "generalTableWithBilling",
        label: "Tabela Geral com faturação",
        fileExt: "xlsx",
        mimeType: XLSX_MIME_TYPE,
        userCanView: user => _.get( user, "groups", [] ).find( group => group === "Finance" ),
      },
      {
        value: "paymentAnalysis",
        label: "Análise de prescrições",
        fileExt: "xlsx",
        mimeType: XLSX_MIME_TYPE,
      },
      {
        value: "paymentAnalysisV2",
        label: "Análise de prescrições agrupada",
        fileExt: "xlsx",
        mimeType: XLSX_MIME_TYPE,
      },
      {
        value: "judgementList",
        label: "Listagem de julgamentos",
        fileExt: "xlsx",
        mimeType: XLSX_MIME_TYPE,
      },
      {
        value: "monthlyPayments",
        label: "Pagamentos mensais",
        fileExt: "pdf",
        mimeType: "application/pdf",
      },
    ], report => {
      return report.userCanView
        ? report.userCanView( _.get( this.props, "user" ) )
        : true
    } )

    return (
      <Dropdown
        auto
        className={style.exportMenu}
        onChange={reportName => {
          if ( reportName === "none" ) {
            return
          }

          generateReport(
            this.props.auth.token,
            reportName,
            this.props.pickedDebts,
            this.props.filters
          )
            // TODO: This isn't great, the backend should set the response headers
            // in a manner that is suitable for downloading.
            .then( r => r.arrayBuffer().then( buffer => {
              const report = _.find( reportTypes, { value: reportName } )
              return {
                buffer,
                filename: [ report.label, report.fileExt ].join( "." ),
                mimeType: report.mimeType,
              }
            } ) )
            .then( ( { buffer, filename, mimeType } ) => {
              download( buffer, filename, mimeType )
            } )
            .catch( () => toastr.error( strings.generalStrings.errorExportingReport ) )
        }}
        source={reportTypes}
        value="none"
      />
    )
  }

  render () {
    const pickedDebtsLenght = this.props.pickedDebts ? this.props.pickedDebts.length : 0
    const { items, userConfig, loadMore, hasMoreItems, configItemMap } = this.props
    // This should be `userConfig`
    const finalConfig = {
      name: true,
      nif: true,
      debtValue: true,
      clientName: true,
    }
    const preparedColumns = this.prepareColumns( finalConfig, TRANSLATION_TABLE, configItemMap )
    const preparedItems = this.prepareItems( items )

    return (
      <div className={style.debtList}>
        <BigList
          loadMore={loadMore}
          hasMoreItems={hasMoreItems}
          items={preparedItems}
          columns={preparedColumns}
          itemsPerPage={this.props.itemsPerPage}
          handlePageChange={this.props.handlePageChange}
          totalItems={this.props.totalItems}
          activePage={this.props.activePage}
          enablePagination={true}
          renderItems={this.renderRows}
          snakeEnabled={pickedDebtsLenght > 0}
        />
        <div style={{ "height": pickedDebtsLenght > 0 ? "100px" : "10px", flex: "1" }}/>
        <Snackbar
          className={styles.snackBarCss}
          active={pickedDebtsLenght > 0}
        >
          <div className={styles.snackBarContent}>
            <div className={styles.snackBarContent}>
              <div className={styles.numberOfPickedDebtsBox}>
                {pickedDebtsLenght} / {this.props.totalItems}
              </div>
              <div className={styles.snackBarTextCss}>
                {strings.generalStrings.selectedDebts}
              </div>
            </div>
            <div style={{ flex: "2" }} className={styles.snackBarContent}>
              {this.renderExportMenu()}
              <Button className={styles.snackBarButtons} flat>{strings.generalStrings.sendInterpellationLetter}</Button>
              <Button onClick={this.submitToCitius} className={styles.snackBarButtons} flat>{strings.generalStrings.submitToCitius}</Button>
            </div>
            <div className={styles.snackBarContent} />
          </div>
        </Snackbar>
      </div>
    )
  }
}

export default connect( store => ( {
  auth: store.auth,
  user: store.user,
} ) )( withRouter( DebtList ) )



// WEBPACK FOOTER //
// ./src/components/DebtList/index.jsx